// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../stylesheets/variables.css\"","customBaseFont":"Muli","customBaseFontBronx":"Bronx"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/stylesheets/fonts.css
// module id = 213
// module chunks = 0 1 2